import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MailCheck } from 'lucide-react';
import AuthShell from '../../components/AuthShell';
import { TextField } from '../../components/Fields';
import { requestPasswordResetApi } from '../../api';
import { validateEmail } from '../../validators';
import { useCooldown, formatarCooldown } from '../../hooks/useCooldown';

export default function EsqueciSenha() {
    const [email, setEmail] = useState('');
    const [erro, setErro] = useState();
    const [enviando, setEnviando] = useState(false);
    const [enviado, setEnviado] = useState(false);
    const cooldown = useCooldown('ueb_reset_senha_cooldown', 10);

    const enviar = async (ev) => {
        ev.preventDefault();
        const v = validateEmail(email);
        if (!v.valid) return setErro(v.error);
        if (cooldown.isActive) return;
        setEnviando(true);
        try {
            await requestPasswordResetApi({ email });
            setEnviado(true);
            cooldown.start();
        } catch {
            // O backend responde 200 mesmo pra email inexistente (não revela).
            // Só cai aqui em erro de rede — mostra sucesso mesmo assim.
            setEnviado(true);
            cooldown.start();
        } finally {
            setEnviando(false);
        }
    };

    if (enviado) {
        return (
            <AuthShell>
                <div className="ueb-auth-card pcenter">
                    <div className="ueb-auth-ico"><MailCheck size={40} /></div>
                    <h1>Verifique seu email</h1>
                    <p className="ueb-auth-sub">
                        Se houver uma conta com <strong>{email}</strong>, enviamos um link para
                        redefinir sua senha. Ele vale por 60 minutos.
                    </p>
                    {cooldown.isActive && (
                        <p className="phint">Poderá reenviar em {formatarCooldown(cooldown.secondsLeft)}.</p>
                    )}
                    <Link className="pbtn pbtn--ghost pbtn--block" to="/login" style={{ marginTop: 12 }}>
                        Voltar ao login
                    </Link>
                </div>
            </AuthShell>
        );
    }

    return (
        <AuthShell>
            <form className="ueb-auth-card" onSubmit={enviar}>
                <h1>Esqueci minha senha</h1>
                <p className="ueb-auth-sub">Informe seu email e enviaremos um link para criar uma nova senha.</p>

                <TextField
                    id="email"
                    label="Email"
                    type="email"
                    autoComplete="email"
                    placeholder="voce@email.com"
                    value={email}
                    onChange={(e) => { setEmail(e.target.value); setErro(undefined); }}
                    error={erro}
                />

                <button className="pbtn pbtn--primary pbtn--block pbtn--lg" type="submit" disabled={enviando || cooldown.isActive}>
                    {enviando ? <span className="pspin" /> : cooldown.isActive ? `Aguarde ${formatarCooldown(cooldown.secondsLeft)}` : 'Enviar link'}
                </button>

                <p className="ueb-auth-foot">
                    Aluno antigo sem email cadastrado? <Link className="plink" to="/recuperar-conta">Recuperar conta</Link>
                </p>
                <p className="ueb-auth-foot"><Link className="plink" to="/login">Voltar ao login</Link></p>
            </form>
        </AuthShell>
    );
}
